var map = {
	"./event/backgroundFetchFileProgress.schema.json": 85596,
	"./event/crossPlatformEvent.schema.json": 78039,
	"./event/faceRecognitionResult.schema.json": 17624,
	"./event/generateMeme.schema.json": 96766,
	"./event/onDownloadTaskCompleted.schema.json": 70362,
	"./event/pause.schema.json": 2335,
	"./event/receiveTrickleMessage.schema.json": 22818,
	"./event/resume.schema.json": 57735,
	"./event/uploadCompleted.schema.json": 97182,
	"./event/uploadError.schema.json": 33586,
	"./event/uploadProgress.schema.json": 35413,
	"./event/viewDidAppear.schema.json": 25962,
	"./event/viewDidDisappear.schema.json": 45581,
	"./method/addDownloadTask.schema.json": 19313,
	"./method/authorizeCalendarStatus.schema.json": 60233,
	"./method/backgroundFetchFile.schema.json": 76320,
	"./method/closeGiftRain.schema.json": 67067,
	"./method/closeReactViewWithTransition.schema.json": 89906,
	"./method/closeView.schema.json": 43286,
	"./method/findCalendarEvent.schema.json": 41097,
	"./method/getABFlag.schema.json": 18543,
	"./method/getAdsConfig.schema.json": 74919,
	"./method/getAdsResourcePath.schema.json": 15815,
	"./method/getContact.schema.json": 9663,
	"./method/getCoverFromLocalVideo.schema.json": 85405,
	"./method/getCurrentGeolocation.schema.json": 78490,
	"./method/getDeviceInfo.schema.json": 73076,
	"./method/getDownloadingTaskCount.schema.json": 15994,
	"./method/getHybridContainerContextInfo.schema.json": 1593,
	"./method/getItem.schema.json": 21850,
	"./method/getNetworkType.schema.json": 40850,
	"./method/getPasteBoard.schema.json": 44839,
	"./method/getSupportedEvents.schema.json": 21796,
	"./method/getSwimLaneInfo.schema.json": 48303,
	"./method/getTrackEnv.schema.json": 99311,
	"./method/getUserInfo.schema.json": 22822,
	"./method/getXhsLogUrl.schema.json": 40782,
	"./method/isAppInstalled.schema.json": 86566,
	"./method/liveOpenShoppingList.schema.json": 92920,
	"./method/liveShare.schema.json": 26560,
	"./method/openComment.schema.json": 86765,
	"./method/openDownloadedFile.schema.json": 68582,
	"./method/openGiftPanel.schema.json": 85459,
	"./method/openHalfWebView.schema.json": 41047,
	"./method/openThirdApp.schema.json": 3393,
	"./method/openXhsSystemSettings.schema.json": 58228,
	"./method/queryBackgroundFetchFileStatus.schema.json": 7284,
	"./method/recordVideo.schema.json": 95211,
	"./method/registerTrickleConnectTopic.schema.json": 30028,
	"./method/removeCalendarEvent.schema.json": 1023,
	"./method/removeItem.schema.json": 51169,
	"./method/saveCalendarEvent.schema.json": 14587,
	"./method/scanQrcode.schema.json": 21522,
	"./method/sendClientRequestV3.schema.json": 69585,
	"./method/sendCrossPlatformEvent.schema.json": 39537,
	"./method/sendLog.schema.json": 70563,
	"./method/setItem.schema.json": 72801,
	"./method/setStatusBarStyleIOS.schema.json": 20096,
	"./method/shareContentToFriend.schema.json": 80783,
	"./method/shareToFriend.schema.json": 80021,
	"./method/shareToQQ.schema.json": 51250,
	"./method/shareToQQSpace.schema.json": 33024,
	"./method/shareToSinaWeibo.schema.json": 21113,
	"./method/shareToWechatSession.schema.json": 87484,
	"./method/shareToWechatTimeline.schema.json": 13451,
	"./method/shareToWechatWork.schema.json": 73893,
	"./method/shortVibrate.schema.json": 87989,
	"./method/springFestivalEmoji.schema.json": 3988,
	"./method/subscribeSchedule.schema.json": 88135,
	"./method/updateBackgroundFetchFileStatus.schema.json": 29885,
	"./method/updateBundle.schema.json": 40777,
	"./method/upload.schema.json": 29347,
	"./method/vibrate.schema.json": 44793,
	"./method/xhsOpenSdkGetCurrentGeolocation.schema.json": 91261,
	"./method/xhsOpenSdkInit.schema.json": 38061,
	"./method/xhsOpenSdkLogin.schema.json": 8146,
	"./method/xhsOpenSdkPay.schema.json": 74888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19102;